/**
 * 类名合并工具函数
 * 用于合并多个类名，自动过滤空值和重复项
 *
 * @param classes - 类名数组，支持字符串、undefined、null、false等
 * @returns 合并后的类名字符串
 *
 * @example
 * ```tsx
 * cn('base-class', 'text-blue-500', null, undefined, 'hover:bg-blue-100')
 * // => 'base-class text-blue-500 hover:bg-blue-100'
 *
 * cn('btn', variant === 'primary' && 'btn-primary', className)
 * // => 'btn btn-primary custom-class'
 * ```
 */
export function cn(...classes) {
    return classes
        .filter(Boolean) // 过滤掉 falsy 值
        .join(' ') // 用空格连接
        .replace(/\s+/g, ' ') // 将多个连续空格替换为单个空格
        .trim(); // 去除首尾空格
}
export default cn;
//# sourceMappingURL=cn.js.map